const CLIENT_SCHEMA = {
  name: 'String',
  stage: 'String',
  status: 'String',
  logoFileName: 'String',
  emailDomains: '[String]',
  primaryContact: 'UserInput',
  secondaryContact: 'UserInput',
  accountManager: 'UserInput',
  technicianGroups: '[GroupInput]',
  site: 'SiteInput',
  customFields: 'JSON',
  accountId: 'ID'
};

const getClientFields = () => {
  return [
    'accountId',
    'name',
    'stage',
    'status',
    'logoFileName',
    'emailDomains',
    'customFields',
    {
      primaryContact: [
        'userId',
        'name',
        'email',
        'phoneNumber',
        'contactNumber'
      ]
    },
    {
      secondaryContact: [
        'userId',
        'name',
        'email',
        'phoneNumber',
        'contactNumber'
      ]
    },
    {
      accountManager: [
        'userId',
        'name',
        'email',
        'phoneNumber',
        'contactNumber'
      ]
    },
    {
      technicianGroups: ['name', 'groupId']
    }
  ];
};

const BUSINESS_HOURS = [
  {
    day: 'MONDAY',
    start: '09:00',
    end: '17:00'
  },
  {
    day: 'TUESDAY',
    start: '09:00',
    end: '17:00'
  },
  {
    day: 'WEDNESDAY',
    start: '09:00',
    end: '17:00'
  },
  {
    day: 'THURSDAY',
    start: '09:00',
    end: '17:00'
  },
  {
    day: 'FRIDAY',
    start: '09:00',
    end: '17:00'
  }
];
// View ids for client modules
const VIEW_ID = {
  approvedInvoice: {
    label: 'Approved invoice',
    viewId: '102'
  },
  unknownTicket: {
    label: 'Unknown ticket',
    viewId: '18'
  },
  invoiceAudit: {
    label: 'Invoice Audit',
    viewId: '101'
  },
  billingQueue: {
    label: 'Billing Queue',
    viewId: '102'
  },
  ignoredItems: {
    label: 'Ignored items',
    viewId: '103'
  }
};

/* Hotjar tracking code */
const hotjarTracking = () => {
  // const hotjarTrackingCode = `(function(h,o,t,j,a,r){
  //   h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  //   h._hjSettings={hjid:2668346,hjsv:6};
  //   a=o.getElementsByTagName('head')[0];
  //   r=o.createElement('script');r.async=1;
  //   r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  //   a.appendChild(r);
  // })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
  const hotjarTrackingCode = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-MC23WGM')`;
  const script = document.createElement('script');
  script.className = 'hotjar';
  script.innerHTML = hotjarTrackingCode;
  return script;
};

export const ACTIONS = Object.freeze({
  ADD: 'add',
  REMOVE: 'remove',
  UPDATE: 'update'
});

export {
  CLIENT_SCHEMA,
  getClientFields,
  BUSINESS_HOURS,
  VIEW_ID,
  hotjarTracking
};
